import React, { useContext, useEffect, useState } from 'react';
import { 
  Box, 
  Typography, 
  Button, 
  Grid, 
} from '@mui/material';
import { styled } from '@mui/material/styles';
import AutomationCard from './common/AutomationCard';
import kavidaLogo from '../../assets/images/userOnboarding/kavidaLogo.png';
import agentMask from '../../assets/images/userOnboarding/agentMask.png';
import playCircle from "../../assets/images/userOnboarding/play-circle.svg";
import addCircle from "../../assets/images/userOnboarding/add-circle.svg";
import { useNavigate } from 'react-router-dom';
import VideoOverlay from "./common/VideoOverlay";
import { userOnboardingContext } from '../../states/context/userOnboardingContext';

const Root = styled(Box)({
  height: '100%',
  overflow: 'hidden',
});

const LogoImg = styled('img')(({ theme }) => ({
  width: 120,
  marginBottom: theme.spacing(2),
}));

const AvatarImg = styled('img')(({ theme }) => ({
  width: theme.spacing(7),
  height: theme.spacing(7),
  marginBottom: theme.spacing(2),
}));

const StyledCard = styled(Box)({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
});

const StyledCardContent = styled(Box)({
  flexGrow: 1,
});

const NewChip = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.info.light,
  marginRight: theme.spacing(1),
}));

const CategoryChip = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.grey[300],
}));

const EnabledCountContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  marginBottom: '8px',
});

const CountText = styled(Typography)({
  fontFamily: 'Figtree',
  fontSize: '32px',
  fontStyle: 'normal',
  fontWeight: '600',
  lineHeight: 'normal',
});

const EnabledCountText = styled(CountText)({
  color: '#1A99A3',
});

const TotalCountText = styled(CountText)({
  color: '#D1D1D1',
});

const OnboardingLeftContent = styled(Grid)({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  overflowY: 'auto',
  height: '100%',
  '&.MuiGrid-item': {
    padding: '90px',
  },
  '@media (max-width: 1000px)': {
    height: 'auto'
  }
});

const AutomationTitle = styled(Typography)({
  color: '#171717',
  fontFamily: 'Figtree',
  fontStyle: 'normal',
  fontSize: '32px',
  fontWeight: '600',
  lineHeight: 'normal',
  margin: '20px 0 24px 0'
});

const AutomationText = styled(Typography)({
  fontFamily: 'Figtree',
  color: '#747474',
  fontStyle: 'normal',
  fontSize: '16px',
  fontWeight: '400',
  lineHeight: 'normal',
  marginBottom: '24px'
});

const AutomationButton = styled(Button)({
  textTransform: 'none',
  marginBottom: '16px',
  color: '#6933FF',
  fontFamily: 'Figtree',
  fontSize: '16px',
  fontStyle: 'normal',
  fontWeight: '600',
  lineHeight: 'normal',
  '&.MuiButton-text': {
    padding: '6px 0'
  }
});

const FullyAutomationButton = styled(Button)({
  textTransform: 'none',
  color: '#6933FF',
  fontFamily: 'Figtree',
  fontSize: '16px',
  fontStyle: 'normal',
  fontWeight: '600',
  lineHeight: 'normal',
  '&.MuiButton-text': {
    padding: '6px 0'
  }
});

const AutomationSubmitButton = styled(Button)({
  textTransform: 'none',
  color: '#FFF',
  display: 'inline-flex',
  padding: '14.5px 32px',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '10px',
  borderRadius: '8px',
  backgroundColor: '#6933FF',
  fontSize: '16px',
  marginTop: '24px',
  maxWidth: '250px',
  '&:hover': {
    backgroundColor: '#6933FF',
  },
});

const AutomationRecommendedText = styled(Typography)({
  color: '#171717',
  fontFamily: 'Figtree',
  fontSize: '24px',
  fontStyle: 'normal',
  fontWeight: '600',
  lineHeight: 'normal',
});

const ReleventAutomationText = styled(Typography)({
  color: '#171717',
  fontFamily: 'Figtree',
  fontSize: '24px',
  fontStyle: 'normal',
  fontWeight: '600',
  lineHeight: 'normal',
  marginBottom: '24px'
});

const AutomationRightContent = styled(Grid)({
  backgroundColor: '#F7F7F7',
  height: '100%', 
  overflowX: 'hidden',
  overflowY: 'auto',
  '&.MuiGrid-item': {
    padding: '90px',
    '@media (min-width: 1280px)': {
      padding: '90px'
    }
  },
  '@media (max-width: 1000px)': {
    height: 'auto'
  }
});

const AiAgentIcon = styled('img')({
  marginTop: '64px'
});

const AddCircle = styled('img')({
  marginRight: '4px'
});

const Automations = () => {
  const navigate = useNavigate();
  const { user, setUser } = useContext(userOnboardingContext);
  const { recommendedAutomations, relevantAutomations } = user;

  const handleSubmit = () => {
    /* todo: Route to SSO */
    navigate("/onboarding/completed");
  };
  const [isOverlayOpen, setOverlayOpen] = useState(false);
  const [enabledCount, setEnabledCount] = useState()

  const handleVideoOverlay = () => {
    setOverlayOpen(true);
  };
  const closeOverlay = () => setOverlayOpen(false);

  const handleAllAutomationEnabled = () => {
    const allAutomationEnabled= recommendedAutomations.map(item =>{
    return { ...item, enabled: true }
    });
    setUser({
      ...user,
      recommendedAutomations:allAutomationEnabled
    })
  }

  useEffect(() => {
    const enableCount = recommendedAutomations.filter(item => item.enabled === true).length;
    setEnabledCount(enableCount)
  },[recommendedAutomations])

  return (
    <>
    <Root>
      <Grid container spacing={0} style={{ height: '100%', overflowY: 'auto' }}>
        <OnboardingLeftContent item xs={12} md={4}>
          <img src={kavidaLogo} alt="KavidaLogo" width={118} height={24}/>
          <AiAgentIcon src={agentMask} alt="AI Agent Icon" width={48} height={48}/>
          <AutomationTitle variant="h1" component="h1">
            Tailored automations by Agent PO
          </AutomationTitle>
          <AutomationText>
            Based on the information you've provided, Agent PO has identified and recommends specific automations that can be executed on your behalf.
          </AutomationText>
          <AutomationText>
            These can be customized later in settings.
          </AutomationText>
          <div style={{ marginBottom: '84.5px' }}>
            <AutomationButton onClick={handleVideoOverlay}>
            <img
              src={playCircle}
              alt="playCircle"
              style={{ marginRight: '4px' }}
            />
              Watch how automations work
            </AutomationButton>
          </div>
          <EnabledCountContainer>
            <EnabledCountText>{enabledCount}</EnabledCountText>
            <TotalCountText>/{recommendedAutomations.length}</TotalCountText>
          </EnabledCountContainer>
          <AutomationText>Recommended automations enabled</AutomationText>
          <AutomationSubmitButton onClick={handleSubmit}>
            {enabledCount > 0 ? "Activate and get started" : "Get started" }
          </AutomationSubmitButton>
        </OnboardingLeftContent>
        <AutomationRightContent item xs={12} md={8}>
          <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
            <AutomationRecommendedText>
              Recommended for you
            </AutomationRecommendedText>
            <FullyAutomationButton onClick={handleAllAutomationEnabled}>
              <AddCircle
                src={addCircle}
                alt="addCircle"
              />
              Enable all recommended
            </FullyAutomationButton>
          </Box>
          <Grid container spacing={3}>
            {recommendedAutomations.map((automation, index) => (
              <Grid item xs={12} sm={6} key={index}>
                <AutomationCard {...automation} automationType="recommended" />
              </Grid>
            ))}
          </Grid>
          <ReleventAutomationText style={{ marginTop: '70px' }}>
            Other relevant automations
          </ReleventAutomationText>
          <Grid container spacing={3}>
            {relevantAutomations.map((automation, index) => (
              <Grid item xs={12} sm={6} key={index}>
                <AutomationCard {...automation} automationType="relevant" />
              </Grid>
            ))}
          </Grid>
        </AutomationRightContent>
      </Grid>
    </Root>
    {isOverlayOpen && (
      <VideoOverlay
        videoId="NdygTNST4l8"
        isOpen={isOverlayOpen}
        onClose={closeOverlay}
      />
    )}
    </>
  );
};

export default Automations;
